const useStateManager = () => {
  return {};
};

export default useStateManager;
